import { library } from '@fortawesome/fontawesome-svg-core'
import { faSeedling, faShare, faSpellCheck, faCheck, faCross, faCheckDouble } from '@fal'
library.add(faSeedling, faShare, faSpellCheck, faCheck, faCross, faCheckDouble)